export const CONNECTED_DEVICE = "CONNECTED_DEVICE";
export const RESTORE_BUTTON_TAB_CONF = "RESTORE_BUTTON_TAB_CONF";

export const SET_FATAL_LOG = "SET_FATAL_LOG";
export const CHANGE_APP_LANG = "CHANGE_APP_LANG";

export function convertIntToHexString(intNum, bytes) {
  if (intNum > 255 && bytes === 1) {
    console.error(
      "Incorrect number " + intNum + " convert to " + bytes + " hex string"
    );
  }

  let result = intNum.toString(16).padStart(2 * bytes, "0");
  if (result.length % 2 !== 0) {
    console.error(
      "Incorrect number " + intNum + " convert to " + bytes + " hex string"
    );
  }

  //let ret = result.replace(/(..)/g, "$1 ");
  let bigEnd = result.trim();

  const groups = bigEnd.match(/.{2}/g); // ["12", "34", "56", "78"]
  const reversed = groups.reverse();
  return reversed.join(" ").toUpperCase();
}

export function convertIntToHexStringKeep(intNum, bytes) {
  if (intNum > 255 && bytes === 1) {
    console.error(
      "Incorrect number " + intNum + " convert to " + bytes + " hex string"
    );
  }

  let result = intNum.toString(16).padStart(2 * bytes, "0");
  if (result.length % 2 !== 0) {
    console.error(
      "Incorrect number " + intNum + " convert to " + bytes + " hex string"
    );
  }

  //let ret = result.replace(/(..)/g, "$1 ");
  let bigEnd = result.trim();
  const groups = bigEnd.match(/.{2}/g); // ["12", "34", "56", "78"]

  return groups.join(" ").toUpperCase();
}

export function hexStringToInt(hexStr) {
  // 去掉空格并合并成一个完整的十六进制字符串
  const cleanHex = hexStr.replace(/\s+/g, "");

  // 使用 parseInt 将十六进制字符串转换成整数
  const intValue = parseInt(cleanHex, 16);

  return intValue;
}
